/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { FC, useEffect, useState } from 'react';
import { ValesData } from '../../types/Types';
import { StorageHelper } from '../../utils/StorageHelper';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import CondLegalesModal from './condLegalesModal';
import BodyTop from './Caprabo/BodyTop';
import ValeCoreBody from './Caprabo/ValeCoreBody';
import NoVales from './NoVales';
import { useValeContext } from './context/Vale.context';
import { FiltersConstants } from '../../utils/FiltersConstants';

interface Props {
  isApp: boolean;
  hayVales: boolean;
  view: boolean;
  valesNoAct: ValesData[];
  retrieveValesAhorro: any;
  isMobile: boolean;
  handleVerMasClick: any;
  valesAct: ValesData[];
  valesPreAct: ValesData[];
  valesCanj: ValesData[];
  existVales: boolean;
  urlMDScrollPreferencia: string;
  filtrosVisiblesProductos: string[];
  filtrosVisiblesOtros: string[];
  isFiltrosSoportePostalVisible: boolean;
  filtrosOtros: string[];
  filtrosProductos: string[];
}
function mostrarValesHtml(lsValesVisibles: ValesData[]) {
  lsValesVisibles.map((vale) => {
    const cuponHtml = document.querySelector(`[data-id='${vale.valeEAN}']`);
    cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
    cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_OCULTOS);
    cuponHtml?.classList.add(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
    return true;
  });
}
const ValesCaprabo: FC<Props> = (props) => {
  const {
    isApp,
    hayVales,
    filtrosOtros,
    filtrosProductos,
    filtrosVisiblesOtros,
    isFiltrosSoportePostalVisible,
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [promocion, setPromocion] = useState<boolean>(false);
  const {
    loadFilterProducs,
    loadFilterOtros,
    loadFiltrosOtrosAMostrar,
    loadIsFiltrosSoportePostalVisible,
  } = useValeContext();

  const setStyle = () => {
    const isEcommerceBot = StorageHelper.isEcommerceBot();
    StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
  };
  useEffect(() => {
    loadFilterProducs(filtrosProductos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosProductos]);
  useEffect(() => {
    loadFilterOtros(filtrosOtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosOtros]);
  useEffect(() => {
    loadFiltrosOtrosAMostrar(filtrosVisiblesOtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosVisiblesOtros]);
  useEffect(() => {
    loadIsFiltrosSoportePostalVisible(isFiltrosSoportePostalVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFiltrosSoportePostalVisible]);

  const {
    activeFilters,
    filtrosOtrosActivos,
    valesVisiblesSFNoActivados,
    voucherNotActWithFilterApplied,
    valesVisiblesSFActivados,
    voucherActWithFilterApplied,
    valesVisiblesSFCanjeados,
    voucherCanjWithFilterApplied,
    valesVisiblesSFPromos,
    voucherPromoWithFilterApplied,
  } = useValeContext();
  useEffect(() => {
    if (activeFilters.length > 0 || filtrosOtrosActivos.length > 0) {
      mostrarValesHtml(voucherNotActWithFilterApplied);
      mostrarValesHtml(voucherActWithFilterApplied);
      mostrarValesHtml(voucherCanjWithFilterApplied);
      mostrarValesHtml(voucherPromoWithFilterApplied);
    } else {
      mostrarValesHtml(valesVisiblesSFNoActivados);
      mostrarValesHtml(valesVisiblesSFActivados);
      mostrarValesHtml(valesVisiblesSFCanjeados);
      mostrarValesHtml(valesVisiblesSFPromos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeFilters,
    filtrosOtrosActivos,
    voucherNotActWithFilterApplied,
    voucherActWithFilterApplied,
    voucherCanjWithFilterApplied,
    voucherPromoWithFilterApplied,
  ]);

  return (
    <>
      {setStyle}
      <BodyTop {...props} />
      <section className="o-section--large misValesPage">
        <div className="container">
          {hayVales && (
            <ValeCoreBody
              {...props}
              setPromocion={setPromocion}
              setVisible={setVisible}
            />
          )}
          {!hayVales && <NoVales />}
        </div>
      </section>
      <CondLegalesModal
        setPromocion={setPromocion}
        promocion={promocion}
        visible={visible}
        setVisible={setVisible}
      />
    </>
  );
};

export default ValesCaprabo;
